export default "__VITE_PUBLIC_ASSET__9579844b__"